export default {
  load: function (array_img) {
    let promises = 
      array_img
        .filter(o=>typeof o == 'string')
        .map(url => {
          return new Promise((resolve, reject) => {
            let i;
            if (url.indexOf("mp4")!=-1){
              i = new Video()
            }else{
              i = new Image()
            }
            
            i.onload = function () {
              // console.log("loaded")
              resolve("ok")
              console.log("Peloaded: " + url)
            }
            i.onerror = function(){
              reject("ohh")
            }
            i.src = url
          })
        })
    return Promise.all(promises)
  }
}